import { GridRowSelectionModel } from '@mui/x-data-grid';
import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/nnc/nnc');
  }

  unfounded = async (ids: GridRowSelectionModel, justification: string) => {
    return api.post(this.buildUrl('unfounded'), {
      ids: ids,
      justification: justification,
    });
  };
  critical_analysis = async (data: object) => {
    return api.post(this.buildUrl('critical_analysis'), data);
  };

  export = async (data: object) => {
    return await api.get(this.buildUrl('report'), {
      params: data,
      paramsSerializer: {
        indexes: null, // by default: false
      },
      responseType: 'blob',
    });
  };

  exportEntries = async (data: object) => {
    return await api.get(this.buildUrl('report_entries'), {
      params: data,
      paramsSerializer: {
        indexes: null, // by default: false
      },
      responseType: 'blob',
    });
  };
}

export default new API();
